module.exports = __webpack_public_path__ + "img/office-1-mob.c619d7e7.webp";